<template>
  <div id="mainDiv">
    <div id="leftDiv">
      <div class="titleName">待选</div>
      <el-input
        placeholder="请输入组织名称搜索"
        v-model="orgFilter"
        style="width: 75%;float: right;"
        class="input-with-select"
        size="small"
        clearable>
        <el-button slot="append" icon="el-icon-search" @click="inputOrgSearch"></el-button>
      </el-input>
      <hr style="margin-top: 40px"/>
      <div id="treeDiv">
        <el-tree
        v-loading="loading"
      element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          ref="tree"
          :data="treeData"
          show-checkbox
          node-key="id"
          :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <i v-if="data.type === '2'" class="el-icon-office-building"/>
              <i v-else class="el-icon-s-custom"/>

              {{ node.label }}
            </span>
          </span>

        </el-tree>
      </div>
    </div>
    <div id="centerDiv">
      <div>
        <el-button type="primary" icon="el-icon-arrow-left" size="medium" @click="delUsers" plain circle></el-button>
      </div>
      <el-button type="primary" icon="el-icon-arrow-right" size="medium" @click="addOrgsAndUsers" style="margin:10px 0 0 0" plain circle></el-button>
    </div>
    <div id="rightDiv">
      <div class="titleName">已选</div>
      <el-input
        placeholder="请输入姓名搜索"
        v-model="userFilter"
        style="width: 70%;float: right;"
        class="input-with-select"
        size="small"
        clearable>
        <el-button slot="append" icon="el-icon-search" @click="inputUserSearch"></el-button>
      </el-input>
      <hr style="margin-top: 40px"/>
      <div id="tableDiv">
        <el-table
        v-loading="tab_loading"
      element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          border
          size="mini"
          :header-cell-style="{background:'#F5F7FA',color:'#606266'}"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="35">
          </el-table-column>
          <el-table-column
            prop="NAME_"
            align="left"
            header-align="center"
            :show-overflow-tooltip='true'
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="POSITION"
            label="职位"
            align="left"
            header-align="center"
            :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column
            prop="ORG_NAME"
            label="部门"
            lign="left"
            header-align="center"
            :show-overflow-tooltip='true'>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="clear:both"></div>

  </div>
</template>

<script>
  import {getAdmOrgAndUserTree} from "../api/admOrg";
  import {assignOrg2Org, getUserByProOrgId, removeUser2Role} from "../api/proOrg";

  export default {
    name: "AssociatedOrganizationsUsers",
    props: {
      parentMsg: Object
    },
    data() {
      return {
        orgFilter: '',
        userFilter: '',
        treeData: [],
        loading: false,
        tableData: [],
        tab_loading: false,
        totalData: [],
        selectUsers: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    methods:{
      inputOrgSearch() {
        this.getTreeData()
      },
      inputUserSearch() {
        var temp = []
        for (var index in this.totalData) {
          if (this.totalData[index].TYPE_ === '1' && this.totalData[index].NAME_.indexOf(this.userFilter) !== -1){
            temp.push(this.totalData[index])
          }
        }
        this.tableData = temp
      },
      getTreeData() {
        this.loading=true;
        getAdmOrgAndUserTree(this.$qs.stringify({name:this.orgFilter})).then(response => {
          if (response) {
            this.treeData = response
          }
          this.loading=false;
        }).catch((e)=>{this.loading=false;})
      },
      getTableData() {
        this.tab_loading=true;
        getUserByProOrgId(this.$qs.stringify({orgId: this.parentMsg.orgId, type: ''}))
          .then(response => {
            if (response.succeed) {
              this.totalData = response.data
              var temp = []
              for (var index in this.totalData) {
                if (this.totalData[index].TYPE_ === '1'){
                  temp.push(this.totalData[index])
                }
              }

              this.tableData = temp
            } else {
              this.$message({
                message: response.msg,
                showClose: true,
                type: 'error'
              })
            }
            this.tab_loading=false;
        }).catch((e)=>{this.tab_loading=false;})
      },
      handleSelectionChange(selection) {
        this.selectUsers = selection
      },
      addOrgsAndUsers() {
        let arr = this.$refs.tree.getCheckedKeys(false)
        if (arr.length === 0) {
          this.$message({
            type: 'warning',
            message: '请先勾选相应组织及人员!'
          });
          return
        }

        var temp = []
        for (var index in arr) {
          let item = arr[index]
          var have = false
          for (var i in this.totalData) {
            if (this.totalData[i].ADM_ORG_ID === item) {
              have = true
              break
            }
          }

          if (!have) {
            temp.push(item)
          }
        }

        if (temp.length === 0) {
          this.$message({
            type: 'success',
            message: '无新增组织或人员!'
          });
          return
        }

        assignOrg2Org(this.$qs.stringify({orgId: this.parentMsg.orgId, jsonId:JSON.stringify(temp)}))
          .then(response => {
            if (response.succeed) {
              this.getTableData()
              this.$message({
                type: 'success',
                message: '设置成功!'
              });
            } else {
              this.$message({
                message: response.msg,
                showClose: true,
                type: 'error'
              })
            }
          }).catch(error => {
            console.log('error:' + error.toString())
          })
      },
      delUsers() {
        if (this.selectUsers.length === 0) {
          this.$message({
            type: 'warning',
            message: '请先勾选相应人员!'
          });
          return
        }

        var temp = []
        for (var index in this.selectUsers) {
          temp.push(this.selectUsers[index].ADM_ORG_ID)
        }

        removeUser2Role(this.$qs.stringify({orgId: this.parentMsg.orgId, jsonId:JSON.stringify(temp)}))
          .then(response => {
          if (response.succeed) {
            this.getTableData()
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: 'error'
            })
          }
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      }
    },
    watch: {
      parentMsg: {
        immediate:true,
        handler:function() {
          this.orgFilter = ''
          this.userFilter = ''
          this.getTreeData()
          this.getTableData()
        }
      }
    }
  }
</script>

<style scoped>
  #mainDiv {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #leftDiv {
    width: 45%;
    height: 100%;
    float: left;
  }
  #centerDiv {
    left: 45%;
    position: absolute;
    width: 10%;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    top: 35%;
  }
  #rightDiv {
    width: 45%;
    height: 100%;
    float: right;
  }
  #treeDiv {
    width: 100%;
    height: 450px;
    overflow-y: auto;
  }
  #tableDiv {
    width: 100%;
    height: 450px;
  }

  .titleName {
    color: black;
    font-size: 17px;
    font-weight: bold;
    padding: 4px 0;
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/AssociatedOrganizationsUsers.vue